import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const IDLE_TIMEOUT_MS = 20 * 60 * 1000;
const THROTTLE_MS = 2000;

export default function useIdleLogout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const timer = useRef(null);
  const logoutRef = useRef(logout);
  const navigateRef = useRef(navigate);
  const lastReset = useRef(0);

  useEffect(() => { logoutRef.current = logout; }, [logout]);
  useEffect(() => { navigateRef.current = navigate; }, [navigate]);

  const reset = useCallback(() => {
    const now = Date.now();
    if (now - lastReset.current < THROTTLE_MS) return;
    lastReset.current = now;
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      await logoutRef.current();
      navigateRef.current("/prijava");
    }, IDLE_TIMEOUT_MS);
  }, []);

  useEffect(() => {
    const events = ["mousedown", "keydown", "touchstart", "click"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      clearTimeout(timer.current);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [reset]);
}
